export default "__VITE_ASSET__LMsGBjSp__"